export default function FlowScenarioLibrary({ flowCases, selectedCaseId, onSelect, onRemove }) {
    if (!flowCases.length) {
        return (
            <p className="text-sm text-gray-400">
                Nenhum cenário flow. Adicione um caso tipo Fluxo E2E.
            </p>
        );
    }
    return (
        <div className="grid gap-2 sm:grid-cols-2" aria-label="Biblioteca de cenários">
            {flowCases.map((c) => {
                const n = Array.isArray(c.turns) ? c.turns.length : 0;
                const selected = c.id === selectedCaseId;
                return (
                    <div
                        key={c.id}
                        className={`rounded border p-3 text-left ${
                            selected
                                ? "border-laranjinha bg-gray-800/80"
                                : "border-gray-700 bg-gray-800/40"
                        }`}
                    >
                        <button type="button" className="w-full text-left" onClick={() => onSelect(c.id)}>
                            <p className="text-sm text-white font-medium">{c.description || c.id}</p>
                            <p className="text-xs text-gray-400 mt-1">{n} turnos</p>
                            <div className="flex flex-wrap gap-1 mt-2">
                                {(c.tags || []).map((tag) => (
                                    <span
                                        key={tag}
                                        className="text-[10px] px-1.5 py-0.5 rounded bg-gray-700 text-gray-300"
                                    >
                                        {tag}
                                    </span>
                                ))}
                            </div>
                        </button>
                        {onRemove ? (
                            <button
                                type="button"
                                className="mt-2 text-xs text-red-400 hover:text-red-300"
                                onClick={() => onRemove(c.id)}
                            >
                                Remover
                            </button>
                        ) : null}
                    </div>
                );
            })}
        </div>
    );
}
